export default __webpack_public_path__ + "static/media/poltrona.d78037bf.png";